import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { CopyService } from '@amfam/shared/utility/shared-services';

import { addVehicleFeatureQuery } from '../+state/add-vehicle-feature.selectors';

@Injectable({ providedIn: 'root' })
export class AddVehicleGuard {
  constructor(
    private store: Store,
    private router: Router,
    private copyService: CopyService
  ) {}

  canActivate(): Observable<boolean> {
    return this.store.select(addVehicleFeatureQuery.selectCanAddVehicle).pipe(
      tap(c => {
        if (!c)
          this.router.navigate([
            this.copyService.getCopy('policy.addVehicleAfterReloadEntryPoint')
          ]);
      })
    );
  }
}
